export default __webpack_public_path__ + "static/media/5m-min.64b289af.jpg";